import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

import {
    CreateAndEditTagModalProps
} from "./models";

import { t, Trans } from "@lingui/macro";
import { ZPlayFormField } from "commons/fields";
import * as Yup from "yup";
import { withUseFormHook, } from "@sinossi/mates-react-library";
import {ContentProducerService} from "services/content-producer-service";
import {CreateTagRequest, EditTagRequest} from "models/request";

const CreateAndEditTagModalSchema = Yup.object().shape({
    name: Yup.string().required(t({
        id: "caetm-name-required-msg",
        message: "È necessario inserire un nome per poter modificare il tag"
    })),
});

class CreateAndEditTagModal extends React.Component<CreateAndEditTagModalProps & UseFormReturn, {}>
{

    componentDidMount(){
        if(this.props.tag){
            this.props.setValue("name", this.props.tag.value);
        }
    }

    private getValues = () => {
        let value = this.props.getValues("name")
        if(this.props.tag){
            this.editTag(value);
        } else {
            this.createTag(value);
        }
    }

    private editTag = (values: any) => {

        let request: EditTagRequest = {
            value: values
        }

        ContentProducerService.editTag(this.props.tag!.id, request, this.props.editTagCallback, this.props.editTagErrorCallback)
    }

    private createTag = (values: any) => {

        let request: CreateTagRequest = {
            value: values
        }

        ContentProducerService.createTag(request, this.props.createTagCallback, this.props.createTagErrorCallback);
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                color={process.env.REACT_APP_BACKGROUND_COLOR}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    {this.props.tag? <Trans id="caetm-edit-title">Modifica tag</Trans> : <Trans id="caetm-create-title">Aggiungi tag</Trans>}
                </DialogTitle>
                <form>
                    <DialogContent>
                        <Typography mt={-2}>
                            <Trans id="caetm-tag-name-label">Inserisci un tag</Trans>
                        </Typography>
                        <ZPlayFormField
                            label={t({
                                id: "caetm-name",
                                message: "Tag"
                            })}
                            name="name"
                            required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={this.props.closeModal}>
                            <Trans id={"caetm-close-btn"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            type="button"
                            onClick={this.getValues}
                            disabled={this.props.formState.isSubmitting}>
                            {this.props.tag? <Trans id={"caetm-edit-btn"}>Modifica</Trans> : <Trans id={"caetm-create-btn"}>Aggiungi</Trans>}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withUseFormHook<{}>(CreateAndEditTagModal, CreateAndEditTagModalSchema, {});
